import { postApi } from "./auth_helpers";
import { persistStudioTokens } from "./studioEntitlementsApi";

declare global {
  interface Window {
    Razorpay?: any;
  }
}

const loadRazorpay = (): Promise<void> => {
  if (window.Razorpay) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Could not load Razorpay"));
    document.body.appendChild(script);
  });
};

/**
 * Buy one unit of a SaaS module through the existing Razorpay flow (/saas/orders → checkout →
 * /saas/payments/verify). Used for the partner network's NETWORK_EXTRA_PARTNER add-on.
 * Resolves with an error message, or "" once the payment is verified.
 */
export const buyStudioModule = async (moduleId: string, description: string): Promise<string> => {
  const orderRes: any = await postApi(`${process.env.REACT_APP_SERVERURL}/saas/orders`, { module: moduleId });
  if (!orderRes?.success) {
    return orderRes?.message === "MODULE_NOT_PRICED"
      ? "This add-on isn't priced yet. Ask HastKala to add partners for you."
      : orderRes?.message || "Payments are not available right now.";
  }
  const order = orderRes.data;
  await loadRazorpay();
  return new Promise((resolve) => {
    const checkout = new window.Razorpay({
      key: order.keyId,
      amount: order.amount,
      currency: order.currency || "INR",
      name: "HastKalaPramanak",
      description,
      order_id: order.orderId,
      handler: async (response: any) => {
        const verify: any = await postApi(`${process.env.REACT_APP_SERVERURL}/saas/payments/verify`, {
          razorpayOrderId: response.razorpay_order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpaySignature: response.razorpay_signature,
          module: moduleId,
        });
        if (verify?.success) {
          if (verify?.data?.tokens) persistStudioTokens(verify.data.tokens);
          resolve("");
        } else {
          resolve(verify?.message || "Could not confirm payment");
        }
      },
      modal: { ondismiss: () => resolve("Payment cancelled") },
    });
    checkout.open();
  });
};
